import { api } from "../../http";

export const getProjectByUsername = async (username: string): Promise<any> => {
  const response = api
    .get(`/profiles/username/${username}`)
    .then(({ data }) => data);
  return response;
};
